<template>
  <div class="login-container">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" autocomplete="on"
             label-position="left">
      <div class="login-wrap">
        <div class="login-main">
          <div class="login-header">
            <div class="login-logo"><img src="../../images/logo.png" alt="" :style="isMobile?'width: 150px;':'width: 200px;'"></div>
            <div class="l-title">{{systemTitle}}</div>
          </div>
          <div class="login-cell">
            <div class="login-inner">
              <el-form-item prop="username">

                <el-input
                    size="large"
                    ref="username"
                    v-model="loginForm.username"
                    placeholder="用户名"
                    name="username"
                    type="text"
                    tabindex="1"
                    autocomplete="on"
                    class="form-control"
                    prefix-icon="iconfont icon-yonghu"
                />
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                    size="large"
                    :key="passwordType"
                    ref="password"
                    v-model="loginForm.password"
                    :type="passwordType"
                    placeholder="密  码"
                    name="password"
                    tabindex="2"
                    autocomplete="on"
                    @keyup.native="checkCapslock"
                    @blur="capsTooltip = false"
                    @keyup.enter.native="handleLogin"
                    prefix-icon="iconfont icon-artboard12"
                />

              </el-form-item>

              <div class="l-end clearfix">
                <label class="l-check">
                  <input :checked="isSavePassword" @change="onSavePassword" type="checkbox"/><span>记住密码</span>
                </label>
                <!--              <router-link to="/find-password" class="l-link">找回密码</router-link>-->
                <!-- <router-link to="/find-password" class="l-link">找回密码</router-link> -->
              </div>
              <div class="l-button">
                <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:30px;"
                           class="btn-login"
                           @click.native.prevent="handleLogin">登 录
                </el-button>
                <el-footer>
                <el-row style="padding-top:20px;display:flex;justify-content:center;color:gray;">
                    <!-- <div>© 朗云汇天（北京）科技有限公司</div>                     -->
                </el-row>
                <el-row style="display:flex;justify-content:center;color:gray;"> 

                    <div><a href="http://www.beian.miit.gov.cn" target="_blank">京ICP备16062507号-1</a></div>

                </el-row>
                
            </el-footer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>

</template>

<script>
import {Message} from "element-ui";
import {mapGetters} from "vuex";   

export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value.trim().length > 20) {
        callback(new Error('用户名最多20个字符'));
      } else {
        callback();
      }
    }
    const validatePassword = (rule, value, callback) => {
      const minLength = 4;
      if (value.length < minLength) {
        callback(new Error(`密码至少${minLength}位`))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{required: true, trigger: 'blur', validator: validateUsername}],
        password: [{required: true, trigger: 'blur', validator: validatePassword}]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      isSavePassword: false,
      systemTitle:'',
    }
  },
  computed: {
            ...mapGetters(['isMobile']),
        },
  watch: {
    $route: {
      handler: function (route) {
        console.log('路由发生更新', route);
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    }
  },
  created() {
    // window.addEventListener('storage', this.afterQRScan)
  },
  mounted() {
    this.systemTitle = "Microsoft 365支持中心工单系统";//"华风集团媒资管理平台";//
    localStorage.setItem('systemTitle',this.systemTitle);
     this.$store.dispatch("setting/checkDevice");
    //  console.log('ismobile1111',this.isMobile)
    

    if (this.loginForm.username === '') {
      this.$refs.username.focus()
    } else if (this.loginForm.password === '') {
      this.$refs.password.focus()
    }
    this.isSavePassword = !!localStorage.getItem('savePassword');
    console.log('isSavePassword', typeof this.isSavePassword, this.isSavePassword);
    console.log('localStorage', localStorage.getItem('loginInfo'));
    this.isSavePassword && (this.loginForm = JSON.parse(localStorage.getItem('loginInfo')) || {
      username: '',
      password: ''
    })
  },
  destroyed() {

  },
  methods: {
    onSavePassword({target: {checked}}) {
      this.isSavePassword = checked
      console.log(this.isSavePassword);
    },
    toFindPasswordPage() {
      this.$router.push({path: '/find-password', query: this.otherQuery})
    },
    checkCapslock(e) {
      const {key} = e
      this.capsTooltip = key && key.length === 1 && (key >= 'A' && key <= 'Z')
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true
          try {
            console.log('this.loginForm',this.loginForm);
            this.loginForm.isZC=false;
            await this.$store.dispatch('user/login', this.loginForm)
            
            localStorage.setItem('loginInfo', JSON.stringify({
              ...this.loginForm,
              userId: this.$store.state.user.userId,
              roleId:this.$store.state.user.roleId
            }));
            // console.log('a1')
            if (this.isSavePassword) {
              localStorage.setItem('savePassword', this.isSavePassword);
            } else {
              localStorage.removeItem('savePassword');
            }
            // console.log('a2')
            // await store.dispatch('user/getUserCompany', {username, password});
            await this.$store.dispatch('user/getUserMenu');
            // console.log('aa',this.$store.state.user.userId,this.redirect, this.otherQuery);
            this.$router.push({path: '/', query: this.otherQuery})
            this.loading = false
          } catch (e) {
            // Message({message: e, type: 'error', duration: 3 * 1000})
            // Message({message: '账号或密码错误', type: 'error', duration: 3 * 1000})
          } finally {
            this.loading = false
          }

        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    }
  }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #000;
$cursor: #000;


@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}


/* reset element-ui css */
.login-container {
  .el-input__icon {
    font-size: 20px;
    color: gray;
  }

  .el-input {
    display: inline-block;
    height: 50px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 35px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;


      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px white inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid #d9d9d9;
    height: 50px;
    line-height: 48px;
    padding: 0 15px;
    width: 100%;
    font-size: 15px;
    box-shadow: 0 0 0 transparent;
    border-radius: 40px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;


.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 160px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}
</style>
